// extracted by mini-css-extract-plugin
export var menuIcon = "_tp-0";
export var menuIconInline = "_tp-1";